import linkChildrenEn from "@/layout/model/notInMenuRouteEn.js";
const addOrEdit = sessionStorage.getItem("currentCompany");
const linkChildrenGov = [{
  label: "水表详情",
  attrs: {},
  url: "/factory/meter/waterMeter/detail",
  linkParent: {
    label: "水表",
    url: "/factory/meter/waterMeter"
  }
},
{
  label: "水表强检数据详情",
  attrs: {},
  url: "/imperative/waterImperative/detail",
  linkParent: {
    label: "水表强检数据",
    url: "/imperative/waterImperative"
  }
},
{
  label: "热能表强检数据详情",
  attrs: {},
  url: "/imperative/heatImperative/detail",
  linkParent: {
    label: "热能表强检数据",
    url: "/imperative/heatImperative"
  }
},
{
  label: "燃气表强检数据详情",
  attrs: {},
  url: "/imperative/gasImperative/detail",
  linkParent: {
    label: "燃气表强检数据",
    url: "/imperative/gasImperative"
  }
},
{
  label: "其他器具强检数据详情",
  attrs: {},
  url: "/imperative/otherImperative/detail",
  linkParent: {
    label: "其他器具强检数据",
    url: "/imperative/otherImperative"
  }
},
{
  label: "水表出厂检验详情",
  attrs: {},
  url: "/water/waterMeterDtail",
  linkParent: {
    label: "水表出厂检验",
    url: "/factory/verificationInfo/water"
  }
},
{
  label: "热能表温度检验记录",
  attrs: {},
  url: "/heat/heatMeterTempDtail",
  linkParent: {
    label: "热能表出厂检验",
    url: "/factory/verificationInfo/heat"
  }
},
{
  label: "热能表流量检验记录",
  attrs: {},
  url: "/heat/heatMeterDtail",
  linkParent: {
    label: "热能表出厂检验",
    url: "/factory/verificationInfo/heat"
  }
},
{
  label: "燃气表出厂检验详情",
  attrs: {},
  url: "/gas/gasMeterDtail",
  linkParent: {
    label: "燃气表出厂检验",
    url: "/factory/verificationInfo/gas"
  }
},
{
  label: "热能表监控详情",
  attrs: {},
  url: "/monitor/overview/heatMeterDetail",
  linkParent: {
    label: "远程监督总览",
    url: "/monitor/overview"
  }
},
{
  label: "农村机井监控详情",
  attrs: {},
  url: "/monitor/overview/wellDetail",
  linkParent: {
    label: "远程监督总览",
    url: "/monitor/overview"
  }
},
{
  label: "楼户表管理",
  attrs: {},
  url: "/monitor/heatMeters/heatManager/floorManager",
  linkParent: {
    label: "热能表管理",
    url: "/monitor/heatMeters/heatManager"
  }
},
{
  label: "热能表监控详情",
  attrs: {},
  url: "/monitor/heatMeters/detail",
  linkParent: {
    label: "热能表数据监控",
    url: "/monitor/heatMeters/dataMonitor"
  }
},
{
  label: "水表检验详情",
  attrs: {},
  url: "/factory/gov/waterMeterDtail",
  linkParent: {
    label: "出厂检验信息(政府视图)",
    url: "/factory/gov/factoryVerInfo"
  }
},
{
  label: "热能表流量检验记录",
  attrs: {},
  url: "/factory/gov/heatMeterDtail",
  linkParent: {
    label: "出厂检验信息(政府视图)",
    url: "/factory/gov/factoryVerInfo"
  }
},
{
  label: "热能表温度检验记录",
  attrs: {},
  url: "/factory/gov/heatTempMeterDtail",
  linkParent: {
    label: "出厂检验信息(政府视图)",
    url: "/factory/gov/factoryVerInfo"
  }
},
{
  label: "燃气表检验详情",
  attrs: {},
  url: "/factory/gov/gasMeterDtail",
  linkParent: {
    label: "出厂检验信息(政府视图)",
    url: "/factory/gov/factoryVerInfo"
  }
},
{
  label: "企业摸底排查详情",
  attrs: {},
  url: "/enterprise/thoroughInvestige/detail",
  linkParent: {
    label: "摸底排查",
    url: "/enterprise/thoroughInvestige"
  }
},
{
  label: "异常企业详情",
  attrs: {},
  url: "/dashboard/exception/exceptionEnterpriseList/detail",
  linkParent: {
    label: "数据看板",
    url: "/dashboard/index"
  }
},
{
  label: "监控详情",
  attrs: {},
  url: "/enterprise/enterpriseList/detail",
  linkParent: {
    label: "监控列表",
    url: "/enterprise/enterpriseList"
  }
},
{
  label: "企业用电详情",
  attrs: {},
  url: "/enterprise/enterpriseList/detail/eledetail",
  linkParent: {
    label: "监控列表",
    url: "/enterprise/enterpriseList"
  }
},
{
  label: "异常申报",
  attrs: {},
  url: "/enterprise/enterpriseList/detail/declare",
  linkParent: {
    label: "监控列表",
    url: "/enterprise/enterpriseList"
  }
},
{
  label: "监控详情",
  attrs: {},
  url: "/enterprise/enterpriseListG/detail",
  linkParent: {
    label: "监控列表",
    url: "/enterprise/enterpriseListG"
  }
},
{
  label: "企业用电详情",
  attrs: {},
  url: "/enterprise/enterpriseListG/detail/eledetail",
  linkParent: {
    label: "监控列表",
    url: "/enterprise/enterpriseListG"
  }
},
{
  label: "异常申报",
  attrs: {},
  url: "/enterprise/enterpriseListG/detail/declare",
  linkParent: {
    label: "监控列表",
    url: "/enterprise/enterpriseListG"
  }
},
{
  label: "企业申报审核详情",
  attrs: {},
  url: "/declare/detail",
  linkParent: {
    label: "企业申报审核",
    url: "/declare/declareCompany"
  }
},
{
  label: "新建存档",
  attrs: {},
  url: "/declare/newEvent",
  linkParent: {
    label: "事件存档",
    url: "/declare/eventArchiving"
  }
},
{
  label: "企业限产历史记录",
  attrs: {},
  url: "/enterprise/enterpriseList/history",
  linkParent: {
    label: "监控列表",
    url: "/enterprise/enterpriseList"
  }
},
{
  label: "企业限产历史记录",
  attrs: {},
  url: "/enterprise/enterpriseListG/history",
  linkParent: {
    label: "监控列表",
    url: "/enterprise/enterpriseListG"
  }
},
{
  label: "报警(昨日/今日)",
  attrs: {},
  url: "/dashboard/exception/exceptionAlarmInfo/twodays",
  linkParent: {
    label: "报警",
    url: "/dashboard/exception/exceptionAlarmInfo"
  }
},
{
  label: "企业数量",
  attrs: {},
  url: "/dashboard/ControlEnterprise/count",
  linkParent: {
    label: "管控执行",
    url: "/dashboard/index"
  }
},
{
  label: "详情",
  attrs: {},
  url: "/dashboard/ControlEnterprise/areaCount",
  linkParent: {
    label: "管控执行",
    url: "/dashboard/indext"
  }
},
{
  label: "设备管理",
  attrs: {},
  url: "/system/enterpriseManage/deviceTree",
  linkParent: {
    label: "企业管理",
    url: "/system/enterpriseManage"
  }
},
{
  label: "用卡管理",
  attrs: {},
  url: "/system/enterpriseManage/cardmanage",
  linkParent: {
    label: "企业管理",
    url: "/system/enterpriseManage"
  }
},
{
  label: "方案编制",
  attrs: {},
  url: "/plan/formPlan",
  linkParent: {
    label: "方案制定",
    url: "/plan/planEdit"
  }
},
{
  label: "编制",
  attrs: {},
  url: "/plan/doPlan",
  linkParent: {
    label: "方案制定",
    url: "/plan/planEdit"
  }
},
{
  label: "设置",
  attrs: {},
  url: "/plan/planSetting",
  linkParent: {
    label: "方案制定",
    url: "/plan/planEdit"
  }
},
{
  label: "设置",
  attrs: {},
  url: "/plan/planSettingPower",
  linkParent: {
    label: "方案制定",
    url: "/plan/planEdit"
  }
},
{
  label: "设置",
  attrs: {},
  url: "/plan/groupSetting",
  linkParent: {
    label: "方案制定",
    url: "/plan/planEdit"
  }
},
{
  label: "查询",
  attrs: {},
  url: "/plan/planSearch",
  linkParent: {
    label: "方案制定",
    url: "/plan/planEdit"
  }
},
{
  label: "切换方案编制",
  attrs: {},
  url: "/plan/switchPlan",
  linkParent: {
    label: "方案制定2",
    url: "/plan/planEdit2"
  }
},
{
  label: "用电详细信息",
  attrs: {},
  url: "/enterprise/workshopCase/eleDetail",
  linkParent: {
    label: "监控列表",
    url: "/enterprise/enterpriseList"
  }
},
{
  label: "用电详细信息",
  attrs: {},
  url: "/enterprise/enterpriseDevice/producePollutionDevice/detail",
  linkParent: {
    label: "监控列表",
    url: "/enterprise/enterpriseList"
  }
},
{
  label: "用电详细信息",
  attrs: {},
  url: "/enterprise/enterpriseDeviceG/producePollutionDevice/detail",
  linkParent: {
    label: "监控列表",
    url: "/enterprise/enterpriseListG"
  }
},
{
  label: "污防告警",
  attrs: {},
  url: "/alarm/alarmList/governPollutionAlarm",
  linkParent: {
    label: "告警统计",
    url: "/alarm/alarmStatistics"
  }
},
{
  label: "污防告警详情",
  attrs: {},
  url: "/alarm/alarmList/governPollutionAlarm/details",
  linkParent: {
    label: "告警统计",
    url: "/alarm/alarmStatistics"
  }
},
{
  label: "历史记录",
  attrs: {},
  url: "/alarm/alarmList/governPollutionAlarm/hisMessage",
  linkParent: {
    label: "告警统计",
    url: "/alarm/alarmStatistics"
  }
},
{
  label: "限产异常",
  attrs: {},
  url: "/alarm/alarmList/governPollutionAlarm/limitProduction",
  linkParent: {
    label: "告警统计",
    url: "/alarm/alarmStatistics"
  }
},
{
  label: "设备告警",
  attrs: {},
  url: "/alarm/alarmList/otherAlarm",
  linkParent: {
    label: "告警统计",
    url: "/alarm/alarmStatistics"
  }
},
{
  label: "设备告警详情",
  attrs: {},
  url: "/alarm/alarmList/otherAlarm/details",
  linkParent: {
    label: "告警统计",
    url: "/alarm/alarmStatistics"
  }
},
{
  label: "告警名称",
  attrs: {},
  url: "/alarm/alarmList/nameList",
  linkParent: {
    label: "告警列表",
    url: "/alarm/alarmList"
  }
},
{
  label: "告警数量",
  attrs: {},
  url: "/alarm/alarmList/numList",
  linkParent: {
    label: "告警列表",
    url: "/alarm/alarmList"
  }
},
{
  label: "企业详情",
  attrs: {},
  url: "/analysis/analysisCutEmissions/details",
  linkParent: {
    label: "减产减排分析",
    url: "/analysis/analysisCutEmissions"
  }
},
{
  label: "分组管理",
  attrs: {},
  url: "/system/enterpriseManage/deviceTree/group",
  linkParent: {
    label: "企业管理",
    url: "/system/enterpriseManage"
  }
},
{
  label: "分组管理",
  attrs: {},
  url: "/system/enterpriseManage/deviceTree/group1",
  linkParent: {
    label: "企业管理",
    url: "/system/enterpriseManage"
  }
},
{
  label: "联系人管理",
  attrs: {},
  url: "/system/enterpriseManage/contact",
  linkParent: {
    label: "企业管理",
    url: "/system/enterpriseManage"
  }
},
{
  label: "配置管理",
  attrs: {},
  url: "/system/enterpriseManage/monitor",
  linkParent: {
    label: "企业管理",
    url: "/system/enterpriseManage"
  }
},
{
  label: "新增配置管理",
  attrs: {},
  url: "/system/enterpriseManage/monitor/add",
  linkParent: {
    label: "企业管理",
    url: "/system/enterpriseManage"
  }
},
{
  label: "企业列表",
  attrs: {},
  url: "/analysis/analysisAreaIndustry/normal",
  linkParent: {
    label: "异常企业分析",
    url: "/analysis/analysisAreaIndustry"
  }
},
{
  label: "报警发生时间",
  attrs: {},
  url: "/analysis/statisticsAbnormal/alarmTime",
  linkParent: {
    label: "污防异常统计",
    url: "/analysis/statisticsAbnormal"
  }
},
{
  label: "报警详情",
  attrs: {},
  url: "/analysis/statisticsAbnormal/alarmTime/details",
  linkParent: {
    label: "异常企业统计",
    url: "/analysis/statisticsAbnormal"
  }
},
{
  label: "限产企业列表",
  attrs: {},
  url: "/analysis/analysisLimit/list",
  linkParent: {
    label: "限产企业分析",
    url: "/analysis/analysisLimit"
  }
},
{
  label: "企业监控分析",
  attrs: {},
  url: "/dashboard/ControlEnterprise/count/detail",
  linkParent: {
    label: "管控执行",
    url: "/dashboard/ControlEnterprise/list"
  }
},
{
  label: "企业监控分析",
  attrs: {},
  url: "/analysis/analysisAreaIndustry/normal/detail",
  linkParent: {
    label: "异常企业分析",
    url: "/analysis/analysisAreaIndustry"
  }
},
{
  label: "报警详情",
  attrs: {},
  url: "/dashboard/exception/exceptionList/detail",
  linkParent: {
    label: "异常查询",
    url: "/dashboard/index"
  }
},
{
  label: "企业详情",
  attrs: {},
  url: "/dashboard/basicSituation/detail",
  linkParent: {
    label: "基本概况",
    url: "/dashboard/index"
  }
},
{
  label: "大气管控日历",
  attrs: {},
  url: "/plan/calendarControlFromDashboard",
  linkParent: {
    label: "数据看板",
    url: "/dashboard/index"
  }
},
{
  label: "企业重点监控",
  attrs: {},
  url: "/dashboard/monitor/detail",
  linkParent: {
    label: "数据看板",
    url: "/dashboard/index"
  }
},
{
  label: "基本概况",
  attrs: {},
  url: "/dashboard/basicSituation",
  linkParent: {
    label: "数据看板",
    url: "/dashboard/index"
  }
},
{
  label: "产污设备运行",
  attrs: {},
  url: "/dashboard/deviceRunning",
  linkParent: {
    label: "数据看板",
    url: "/dashboard/index"
  }
},
{
  label: "监控分析详情",
  attrs: {},
  url: "/dashboard/monitor",
  linkParent: {
    label: "数据看板",
    url: "/dashboard/index"
  }
},
{
  label: "异常查询",
  attrs: {},
  url: "/dashboard/exception/exceptionList",
  linkParent: {
    label: "数据看板",
    url: "/dashboard/index"
  }
},
{
  label: "已申报异常企业",
  attrs: {},
  url: "/dashboard/exception/exceptionEnterpriseList",
  linkParent: {
    label: "数据看板",
    url: "/dashboard/index"
  }
},
{
  label: "总用电信息",
  attrs: {},
  url: "/dashboard/electricityConsumption",
  linkParent: {
    label: "数据看板",
    url: "/dashboard/index"
  }
},
{
  label: "管控分析详情",
  attrs: {},
  url: "/dashboard/control",
  linkParent: {
    label: "数据看板",
    url: "/dashboard/index"
  }
},
{
  label: "限产企业分析详情",
  attrs: {},
  url: "/analysis/analysisLimit/industry",
  linkParent: {
    label: "限产企业分析",
    url: "/analysis/analysisLimit"
  }
},
{
  label: "限产企业分析详情",
  attrs: {},
  url: "/analysis/analysisLimit/area",
  linkParent: {
    label: "限产企业分析",
    url: "/analysis/analysisLimit"
  }
},
{
  label: "故障申报审核详情",
  attrs: {},
  url: "/declare/troubleProcess/detail",
  linkParent: {
    label: "故障申报审核",
    url: "/declare/troubleProcess"
  }
},
{
  label: "限产企业分析详情",
  attrs: {},
  url: "/analysis/analysisLimit/area/detail",
  linkParent: {
    label: "限产企业分析",
    url: "/analysis/analysisLimit"
  }
},
{
  label: "异常设备明细",
  attrs: {},
  url: "/dashboard/exception/exceptionList/exceptionDeviceDetails",
  linkParent: {
    label: "数据看板",
    url: "/dashboard/index"
  }
},
{
  label: "点位勘察",
  attrs: {},
  url: "/ExplorationAssistant/spotChecking/steps",
  linkParent: {
    label: "现场勘察",
    url: "/ExplorationAssistant/spotChecking"
  }
},
{
  label: "分组管理",
  attrs: {},
  url: "/ExplorationAssistant/spotChecking/equipment/group2",
  linkParent: {
    label: " 设备管理",
    url: "/ExplorationAssistant/spotChecking"
  }
},
{
  label: "分组管理",
  attrs: {},
  url: "/ExplorationAssistant/spotChecking/equipment/group3",
  linkParent: {
    label: " 设备管理",
    url: "/ExplorationAssistant/spotChecking"
  }
},
{
  label: "排污单位",
  attrs: {},
  url: "/ExplorationAssistant/spotChecking/addPolluter",
  linkParent: {
    label: "现场勘察",
    url: "/ExplorationAssistant/spotChecking"
  }
},
{
  label: "设备管理",
  attrs: {},
  url: "/ExplorationAssistant/spotChecking/deviceManage",
  linkParent: {
    label: "现场勘察",
    url: "/ExplorationAssistant/spotChecking"
  }
},
{
  label: "联系人管理",
  attrs: {},
  url: "/ExplorationAssistant/spotChecking/contact",
  linkParent: {
    label: "现场勘察",
    url: "/ExplorationAssistant/spotChecking"
  }
},
{
  label: "分组管理",
  attrs: {},
  url: "/ExplorationAssistant/spotChecking/steps/backupRelation",
  linkParent: {
    label: "现场勘察",
    url: "/ExplorationAssistant/spotChecking"
  }
},
{
  label: "污防异常查询",
  attrs: {},
  url: "/dashboard/ZWExceptionQuery",
  linkParent: {
    label: "数据看板",
    url: "/dashboard/index"
  }
},
{
  label: "污防异常查询 / 查看详情",
  attrs: {},
  url: "/dashboard/ZWExceptionQuery/details",
  linkParent: {
    label: "数据看板",
    url: "/dashboard/index"
  }
},
{
  label: "设备状态",
  attrs: {},
  url: "/dashboard/dashboardEnterpriseInfo/deviceState",
  linkParent: {
    label: "数据看板",
    url: "/dashboard/index"
  }
},
{
  label: "企业信息",
  attrs: {},
  url: "/dashboard/dashboardEnterpriseInfo",
  linkParent: {
    label: "数据看板",
    url: "/dashboard/index"
  }
},
{
  label: "生产设施状态",
  attrs: {},
  url: "/dashboard/DashboardEnterpriseInfoA",
  linkParent: {
    label: "数据看板",
    url: "/dashboard/index"
  }
},
{
  label: "污防设施状态",
  attrs: {},
  url: "/dashboard/DashboardEnterpriseInfoB",
  linkParent: {
    label: "数据看板",
    url: "/dashboard/index"
  }
},
{
  label: "区域负荷统计", // 测试子母路由的跳转实现
  attrs: {},
  url: "/dashboard/areaenCount",
  linkParent: {
    label: "数据看板",
    url: "/dashboard/index"
  }
},
{
  label: "产线模拟图",
  attrs: {},
  url: "/bigScreen/editor",
  linkParent: {
    label: "组件编辑",
    url: "/bigScreen/list"
  }
},
{
  label: "产线模拟图",
  attrs: {},
  url: "monitor/chanxiantu",
  linkParent: {
    label: "组件编辑",
    url: "monitor/chanxiantu"
  }
},
{
  label: "效果预览",
  attrs: {},
  url: "/bigScreen/view",
  linkParent: {
    label: "组件编辑",
    url: "/bigScreen/list"
  }
},
{
  label: "生产关系",
  attrs: {},
  url: "/system/ProductRelationMatch/ProductRelation",
  linkParent: {
    label: "生产关系匹配",
    url: "/system/ProductRelationMatch"
  }
},
];

let linkChildren = [];

linkChildren.push(...linkChildrenGov);
linkChildren.push(...linkChildrenEn);

export default linkChildren;



// WEBPACK FOOTER //
// ./src/layout/model/notInMenuRoute.js